import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=5dfb6654"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectModal.vue?vue&type=style&index=0&id=5dfb6654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports